import '../App.css';
import Charts from'../components/Charts';
import React, { useEffect, useState, useRef} from "react";
import { Paper, Typography, CircularProgress, Box, MenuItem, FormControl, Select, FormHelperText } from '@mui/material';
import {StatsObject} from '../Helper/StatsObject';
import {DefineYAxis} from '../Helper/DefineYAxis';
import DisplacementChart from './DisplacementChart.js';
import {client, w3cwebsocket as W3CWebSocket } from "websocket";
import { globalStateContext, dispatchStateContext } from '../App.js';
import { InteractionStatus } from "@azure/msal-browser";
import TargetForm from './TargetForm.js';
import { BootstrapInput, MyIcon, useStyles } from './TargetForm.js';
import { useMediaPredicate } from "react-media-hook";
import GroupHasData from '../Helper/GroupHasData';
import pruneCache from '../Helper/BufferPrune';
import {updateStats} from '../Helper/UpdatedStats';
import {getToken} from '../Helper/GetToken';
import numActiveGroups from '../Helper/numActiveGroups';
import ArrowLeftOutlinedIcon from '@mui/icons-material/ArrowLeftOutlined';
import { useMsal } from "@azure/msal-react";
import { loginRequest, protectedResources } from "../authConfig";
import setCurrent from "../Helper/setCurrent";
import { useLocation, useNavigate } from 'react-router-dom';
import SelectForm from './ViewConfig/SelectForm';
import BuildViewConfig from '../Helper/BuildViewConfig';
import buildQuery from '../Helper/BuildQuery';
import {useConfig, useConfigDispatch} from './ViewConfig/ConfigProvider'
import { isChartActive } from '../Helper/Chart/chartIsActive';
import { determineYaxisOrientation, isAxisHidden, numActiveCharts } from '../Helper/Chart/yAxisHelpers';
import { configBuilder } from './ViewConfig/ConfigBuilder';
import { getConfigurl, getRheoServerUrl, buildRheoURL, buildConfigURL, getRheoApiWebsocketUrl } from '../Config/config.tsx';
import {useSkidsWithConfig, useSkidsWithConfigDispatch,} from '../components/AvailableSkids/skidsWithConfigProvider'
import { isPopulated, toSelectOptions, mapToSelectOptions } from '../components/AvailableSkids/skidsHelpers';
import {useTracker, useTrackerDispatch} from '../components/FetchTracker/FetchTrackerProvider'
import ToastList from './ToastList/ToastList';
import { fetchAvailableSkidsWithConfigHeaders } from '../Helper/Fetch/fetch';
import Focused from './Display/Focused';
import {getCategories, getCategoriesasStrings} from './ViewConfig/ConfigHelpers'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';




const useGlobalState = () => [
  React.useContext(globalStateContext),
  React.useContext(dispatchStateContext)
];

const LiveChart = (props) =>{
  const locationState = useLocation().state;
  const navigate = useNavigate();
  const [instanceToken, setInstanceToken] = useState(null);
    const [token, setToken] = useState(null);
    const { instance, accounts, inProgress } = useMsal();
    const [time, setTime] = useState(43200);
    const [stats, setStats] = useState(null);
    const [error, setError] = useState('');
    const [isLoaded, setIsLoaded] = useState(true);
    const [liveitems, setLiveItems] = useState([]);
    const [state, dispatch] = useGlobalState();
    const [incoming, setIncoming] = useState([]);
    const [yAxis, setYAxis] = useState([]);
    const [displayDate, setDisplayDate] = useState(null);
    const [temporaryStats, setTemporaryStats] = useState(null);
    const [updatedStats, setUpdatedStats] = useState(null);
    const [displacementItems, setDisplacementItems] = useState(null);
    const [availableSkids, setAvailableSkids] = useState(null);
    const [selectedSkid, setSelectedSkid] = useState(null);
    const [isSkidSelected, setIsSkidSelected] = useState(false);
    const [skidOptions, setSkidOptions] = useState(null);
    const [skidViews, setSkidViews] = useState(null);
    const scrollRef = useRef(null);
    const { myKey } = props;
    const trigger = state.data[6].categories[2].isEnabled;
    const moreThan720 = useMediaPredicate("(min-width: 720px)");
    const baseUrl = 'https://rheo-api.azurewebsites.net';
    const [switching, setSwitching]=useState(false)
    const wsRef = useRef();
    const viewConfig = useConfig();
    const viewConfigDispatch = useConfigDispatch();
    const [numActive,setnumActive] = useState(null)
    const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)
    const [avilableTimezones,setAvailableTimezones] = useState(new Set(["UTC",Intl.DateTimeFormat().resolvedOptions().timeZone,"Europe/Oslo","Europe/London","America/Guyana","Africa/lagos","Asia/Dubai","Asia/singapore","Australia/Perth","America/New_York","America/Los_Angeles","America/Houston"]))
    const skidsWithConfig = useSkidsWithConfig()
    const SkidDispatch = useSkidsWithConfigDispatch()
    const Tracker = useTracker();
    const TrackerDispatch = useTrackerDispatch();
    const fetchingSkidsWithConfigRef = useRef(false)
    const tokenfetchedRef = useRef(false)
    const skidConnectedRef = useRef(false)
    const TimeOptions = [300, 600, 1800, 3600,43200]
    const minute_ms = 60*1000
    const statusUpateInterval = 60
    const TimeOptionDisplay = (option)=>{
      if(option < 3600) {
        return (option/60 + ' minutes')
      }
      return (option/3600 + ' hours')
    }
    const [autoClose, setAutoClose] = useState(true)
    const [autoCloseDuration, setAutoCloseDuration] = useState(600);
    const [toasts, setToasts] = useState([]);
    const toastsRef = useRef([]);
    const [lastMeasurement, setLastMeasurement] = useState({});
    const [showFocused, setShowFocused] = useState(false);
    const lastData = liveitems.length > 0 ? liveitems[liveitems.length - 1] : null;
    toastsRef.current = toasts; // Keep the latest toasts in the ref
    const request = {
        scopes: protectedResources.whoami.scopes,
        account: accounts[0],
      };
    const fetchData = async (delta) => {
    const request = {
        scopes: protectedResources.whoami.scopes,
        account: accounts[0],
      };
      instance.acquireTokenSilent(request).then((response) => {
        console.log('i has config?:')
        //console.log(state.displayConfig.charts)
        console.log(viewConfig.charts)
        const headers = new Headers();
        const bearer = response.accessToken;
        const end = new Date().toISOString();
        headers.append("Authorization", bearer);
        const options = {
          method: "GET",
          headers: headers
        };
        const start = new Date(new Date().getTime() - (1000 * delta)).toISOString();
        const url = buildConfigURL("/explorer")
        
        
          url.search = buildQuery( 
            viewConfig.charts,
            start,
            end,
            skidsWithConfig.get(selectedSkid).name
            )
            fetch(url, options)
            .then(res => res.json())
            .then((items) =>{
              let delta = 0
              if (time > 3600) {
                delta = 60*5
              }
              if (delta != 0){
                items = agregateData(items, delta)
              } 
              setLiveItems(items);
              setLastMeasurement(trackLastMeasurement(items, lastMeasurement));
              var temp_date = null
              if(!items[items.length-1]){
                temp_date = new Date()
              }else{
                var temp_date = new Date(items[items.length-1].timestamp);
              }
              setDisplayDate(temp_date.toLocaleTimeString());
        })
        .catch(error => {
          console.log(error);
        });   
    })
  };
function trackLastMeasurement(items, lastMeasurement) {
  if (items.length === 0) {
    return lastMeasurement;
  }else{
    Object.keys(items[items.length - 1]).forEach(key => {
      if (key !== 'timestamp' && key !== 'OperationHours') {
        lastMeasurement[key] = items[items.length - 1][key];
      }
    });
  }
  return lastMeasurement;
}
function aggregateBucket(bucket) {
  const aggregatedItem = {
    timestamp: bucket[0].timestamp, // Use the timestamp of the first item in the bucket
  };
  let categories = new Map();
  //split into catgeories
  for (let item of bucket) {
    
    for (let [category, value] of Object.entries(item)) {
     
      if (category !== 'timestamp' && category !== 'OperationHours') {
        if (!categories.has(category)) {
          //console.log(`Initializing category: ${category}`);
          categories.set(category, { value: 0, count: 0 });
        }
        
        if (categories.has(category)) {
        
        if (value === null || value === undefined || isNaN(value)) {
          console.log(`Skipping category: ${category} due to invalid value: ${value}`);
          continue; // Skip this category if the value is not a valid number
        }
        categories.get(category).value += value;
        categories.get(category).count += 1;
        }
      }
    }
  }
  // Aggregate each category
  for (let [category, data] of categories.entries()) {
    //console.log(`Aggregating category: ${category}, data: ${JSON.stringify(data)}`);
    aggregatedItem[category] =  data.value / data.count ;
  }   
  //console.log(`Aggregated item: ${JSON.stringify(aggregatedItem)}`);
  return aggregatedItem;
} 
function agregateData(items, delta){
  console.log(`Aggregating data with delta: ${delta} seconds`);
  console.log(`Data before Aggregate:${items}`)
  const aggregated = [];
  const interval = delta * 1000; // Convert delta to milliseconds
  let currentBucketStart = null;
  let currentBucket = [];

  items.forEach(item => {
    const timestamp = new Date(item.timestamp).getTime();

    if (currentBucketStart === null) {
      currentBucketStart = timestamp;
    }

    if (timestamp < currentBucketStart + interval) {
      currentBucket.push(item);
    } else {
      // Aggregate the current bucket
      if (currentBucket.length > 0) {
        const aggregatedItem = aggregateBucket(currentBucket);
        aggregated.push(aggregatedItem);
      }
      // Start a new bucket
      currentBucketStart = timestamp;
      currentBucket = [item];
    }
  });
  console.log(`Aggregated ${items.length} items into ${aggregated.length} items`);
  console.log(`Aggregated data: ${aggregated}`)
  return aggregated;
}
  const fetchDefaultView = async() => {
    const request = {
      scopes: protectedResources.whoami.scopes,
      account: accounts[0],
    };
    instance.acquireTokenSilent(request).then((response) => {
      const headers = new Headers();
      const bearer = response.accessToken;
      const end = new Date().toISOString();
      headers.append("Authorization", bearer);
      const options = {
        method: "GET",
        headers: headers
      };

      const url = buildConfigURL("/GetDefaultSkidView")
      url.search = new URLSearchParams({
          Skid: skidsWithConfig.get(selectedSkid).name
        });
      fetch(url, options)
      .then(res => res.json())
      .then((items) =>{
        console.log(items);
        const rheoMax = state.data[state.data.length -1]
        const displayConfig = BuildViewConfig(items,rheoMax)
        state.displayConfig = displayConfig 
        const newConfig = configBuilder(items)
        viewConfigDispatch({
          type:'updateConfig',
          chart: null,
          category: null,
          config: newConfig,
        })

        ;
  })
  .catch(error => {
    console.log(error);
  });
  });
  };

  const fetchSkidViews = async () =>{
    const request = {
      scopes: protectedResources.whoami.scopes,
      account: accounts[0],
    };
    instance.acquireTokenSilent(request).then((response) => {
      const headers = new Headers();
      const bearer = response.accessToken;
      headers.append("Authorization", bearer);
      const options = {
        method: "GET",
        headers: headers
      };
      const url = buildConfigURL("/GetSkidViews")
      url.search = new URLSearchParams({
        Skid: skidsWithConfig.get(selectedSkid).name
      });
      fetch(url,options)
      .then( res => res.json() )
      .then((items) =>{
        setSkidViews(items.Views)
      })
      .catch(error => {
        setError(error);
      });
    });
  };

  const fetchViewConfig = async (view) =>{
    const request = {
      scopes: protectedResources.whoami.scopes,
      account: accounts[0],
    };
    instance.acquireTokenSilent(request).then((response) => {
      const headers = new Headers();
      const bearer = response.accessToken;
      headers.append("Authorization", bearer);
      const options = {
        method: "GET",
        headers: headers
      };
      //const url = new URL("https://rheoport-api.azurewebsites.net/SwitchView")
      const url = buildConfigURL("/SwitchView")
      url.search = new URLSearchParams({
        View: view,
        Skid: skidsWithConfig.get(selectedSkid).name
      });
      fetch(url,options)
      .then( res => res.json() )
      .then((items) =>{
        console.log(items);
        const rheoMax = state.data[state.data.length -1]
        const displayConfig = BuildViewConfig(items,rheoMax)
        state.displayConfig = displayConfig 
        const newConfig = configBuilder(items)
        viewConfigDispatch({
          type:'updateConfig',
          chart: null,
          category: null,
          config: newConfig,
        })
      })
      .catch(error => {
        setError(error);
      });
    });
  };

  const fetchAvailableSkids = async () => {
    const request = {
      scopes: protectedResources.whoami.scopes,
      account: accounts[0],
    };
    instance.acquireTokenSilent(request).then((response) => {
      const headers = new Headers();
      const bearer = response.accessToken;
      const end = new Date().toISOString();
      headers.append("Authorization", bearer);
      const options = {
        method: "GET",
        headers: headers
      };
      
      //const url = new URL("https://rheoport-api.azurewebsites.net/GetAvailableSkids");
      const url = buildConfigURL("/GetAvailableSkids");
      fetch(url, options)
      .then(res => res.json())
      .then((items) =>{
        setAvailableSkids(items.skids);
  })
  .catch(error => {
    setError('No skids available skids found for this user.');
  });
  })
};

//toast demo
function createToast(alert, type){
        return {
            id: Date.now(),
            message: alert.message+" "+alert.value,
            type:type
            
        }
        }
    

    function showToast(alert, type) {
        const toast = createToast(alert, type)
        console.log("created toast:", toast)
        console.log("old toasts:", toastsRef.current)
        const newToasts = [...toastsRef.current, toast];
        
        console.log("newToasts:", newToasts)
        setToasts(newToasts);
    
        console.log("toasts:", toasts)
        if (autoClose){
            setTimeout(() => {
                removeToast(toast.id)   
            }, autoCloseDuration*1000);
        }
    }
    function removeToast(id){
        console.log("Removing toast with id:", id)
        const newToasts = toastsRef.current.filter(toast => toast.id !== id);
        setToasts(newToasts);
    }
  /*   useEffect(() => {
    const evtSource = new EventSource('http://localhost:4444/value-stream');
    
    

    evtSource.addEventListener("value-event",(event)=>{
            //console.log(event)
            if(event.data){
                const alert = JSON.parse(event.data)
                console.log("Alert:",alert)
                console.log("showToast:",alert.data)
                showTo0ast(alert.data, "warning")
            }
        })
        
    }, []); 
 */
//timer that runs every hour to aggregate the liveitems and update the stats, this is to prevent the liveitems from growing too large and slowing down the app
useEffect(()=>{
  console.log("starting interval to aggregate liveitems")
  const interval = setInterval(()=>{
          console.log('time to refetch skid status')
          setLiveItems(liveitems => agregateData(liveitems, 60*5))
      }, minute_ms*statusUpateInterval)
      return () => clearInterval(interval)

},[])
//Checks if a skid has been passed as an argument, if not it redirects to the select page, only runs on first load
 useEffect( ()=>{
  if (locationState==null){
    navigate('/Select',{state:{origin:'/Live'}})
  }
  if(!switching){
    setSelectedSkid(locationState?.targetSkid)  
  }
},[]) 

//Gets the AD token used to authenticate user to backend, runs when a new skid has been selected
useEffect(()=>{
    async function getInstanceToken(){
      console.log("setting instance token, triggered by selected skid")
      const request = {
        scopes: protectedResources.whoami.scopes,
        account: accounts[0],
      };
    const response = await instance.acquireTokenSilent(request) 
    setInstanceToken(response.accessToken)
    }
    if(!switching){
      getInstanceToken()
    }   
   },[selectedSkid])

useEffect(()=>{
    async function getInstanceToken(){
      console.log("setting instance token, triggered by skidsWithConfig")
      const request = {
        scopes: protectedResources.whoami.scopes,
        account: accounts[0],
      };
    const response = await instance.acquireTokenSilent(request) 
    setInstanceToken(response.accessToken)
    }
    if(!switching){
      getInstanceToken()
    }   
   },[skidsWithConfig])

   // gets the websocket pass token, runs when instance token is changed, this should only happen on first load after a skid is selected
  /*  useEffect(()=>{
    //function to get the token and store it as state
    
    async function getToken(skid){
      console.log("getting connection token, triggered by instance token")
    //const url = new URL("https://rheo-api.azurewebsites.net/token")
    //const url = new URL("http://localhost:8000/token");
    const url = buildRheoURL("/token")
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + instanceToken); 
    const options = {
        method: "GET",
        headers: headers
      };
      url.search = new URLSearchParams({
       skid: skid
     });
     fetch(url, options).then(res=>res.json()).then((body)=>{     
      tokenfetchedRef.current = true 
    setToken(body.token)
     })
    }
    //if an ad token exists it uses it to get the ws token
    if(instanceToken && selectedSkid && isPopulated(skidsWithConfig)&&!tokenfetchedRef.current){
      getToken(skidsWithConfig.get(selectedSkid).name)
      
      fetchDefaultView(skidsWithConfig.get(selectedSkid).name)
      fetchSkidViews(skidsWithConfig.get(selectedSkid).name)

    }   
   },[instanceToken])

   //same as above, but is only ran when selected skid is switching
   useEffect(()=>{
    console.log("checking if switching")
    if(switching&&!tokenfetchedRef.current){
      async function getToken(skid){
        console.log("getting connection token, triggered by selected skid and switching")
      //const url = new URL("https://rheo-api.azurewebsites.net/token")
      const url = buildRheoURL("/token")
      //const url = new URL("http://localhost:8000/token");
      const headers = new Headers();
      headers.append("Authorization", "Bearer " + instanceToken);
      
      const options = {
          method: "GET",
          headers: headers
        };
        url.search = new URLSearchParams({
         skid: skid
       });
       fetch(url, options).then(res=>res.json()).then((body)=>{  
        tokenfetchedRef.current = true   
        setToken(body.token)
       })     
      }

      getToken(skidsWithConfig.get(selectedSkid).name)
      fetchDefaultView(skidsWithConfig.get(selectedSkid).name) 
      fetchSkidViews(skidsWithConfig.get(selectedSkid).name)
    }
   },[selectedSkid])
 */
useEffect(()=>{
  if(token){
    console.log("connecting to websocket with token")
    //fetchAvailableSkids()
    fetchData(time)
    const client = new W3CWebSocket(getRheoApiWebsocketUrl(), token);
      client.onopen = () => { console.log('websocket client connected')};
      client.onmessage = (message) => {
        setIsLoaded(true);
        try{
          let data = JSON.parse(message.data);
        setIncoming(data);
        setCurrent(data, state);
        }catch(error){
          console.log(error)
        }
        
      }
      client.onclose = (close) =>{
        try{
          wsRef.current.send(close)
        console.log("closing client")
        }catch(error){
          console.log(error)
        }
        
      }
      
      wsRef.current = client;
        
  }
return () =>{
    if(!wsRef.current){
      console.log("no websocket")
    }else{
      console.log(wsRef.current)
    
      wsRef.current.close()
    }
  }
},[token])

useEffect(() =>{
    let prunedItems = pruneCache([...liveitems],time);
    let combinedItems = [...prunedItems, ...incoming];
    setLiveItems(liveitems => combinedItems);
    setLastMeasurement(trackLastMeasurement(combinedItems, lastMeasurement));
    if(incoming.length > 0){
      const temp_date = new Date(incoming[incoming.length-1].timestamp);
      setDisplayDate(temp_date.toLocaleTimeString());
    }
}, [incoming]); 

useEffect(()=>{
  if(liveitems.length>0){
    let tempitems = [...liveitems];
    let tempDisplacement = pruneCache(tempitems, 600);
    setDisplacementItems(tempDisplacement);
    let tempStats = new StatsObject(liveitems)
    tempStats.calculateStats()
    if (stats != {}) {
      setTemporaryStats(stats);
    }
    setStats(tempStats)
    let active = numActiveCharts(viewConfig,tempStats)
    setnumActive(active)
    let newYAxis = DefineYAxis(liveitems,time,false,yAxis)
    setYAxis(newYAxis)
  }else{
  }
    
},[liveitems])

useEffect(()=>{
  if(stats === null){
    console.log('waiting for stats');
  }else{
    setUpdatedStats(updateStats(stats,temporaryStats));
    setIsLoaded(true)
    setError('');
  }
},[stats])


useEffect(()=>{
  if (scrollRef.current && trigger) {
    scrollRef.current.scrollIntoView({ behavior: 'smooth' });
  }
}, [trigger]);
// Functions Used to handle select in select form
const handleTimeSelect = (event) => {
  let oldTime = time;
  setTime(event.target.value);
  if(event.target.value>oldTime){
    console.log(`fetching data for new time window: ${event.target.value}`)
    fetchData(event.target.value);
  }else{
    let items = [...liveitems]
  let pruneditems = pruneCache(items,event.target.value)
  setYAxis(DefineYAxis(pruneditems,event.target.value,false,yAxis))
  setLiveItems(pruneditems)
  setLastMeasurement(trackLastMeasurement(pruneditems, lastMeasurement))
  }
  };
const handleSkidSelect = (event) => {
  setIsLoaded(false)
  setSwitching(true)
  setLiveItems([])
  setLastMeasurement({})
  if (wsRef.current){
    wsRef.current.close()
  }
  tokenfetchedRef.current = false
  skidConnectedRef.current = false
  setSelectedSkid(event.target.value)
 
  };
const handleViewSelect = (event) =>{
  console.log(`Selected view ${event.target.value}`)
  fetchViewConfig(event.target.value)
}
const handleTimezoneSelect = (event) =>{
  console.log(`Selected timezone ${event.target.value}`)
  setTimezone(event.target.value)
}
//const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
//setAvailableTimezones(avilableTimezones.add(localTimezone))
//if (selectedSkid){
//  const skidTZ = skidsWithConfig.get(selectedSkid).timezone
//  setAvailableTimezones(avilableTimezones.add(skidTZ))
//  setTimezone(skidTZ)
//}
    useEffect(()=>{
         if(selectedSkid!=null){
            console.log("selected skid:",selectedSkid)
        const skidWithConfig = skidsWithConfig.get(selectedSkid)
        console.log("skid config:",skidWithConfig)
        if(!skidWithConfig){
          console.log("no config for skid")
          
        }else{
          const skidTZ = skidWithConfig.timezone
          console.log("timezone:",skidTZ)
          if (skidTZ){
              console.log("default timezone:",skidTZ)
              setAvailableTimezones(avilableTimezones.add(skidTZ))
              setTimezone(skidTZ)
          }

        }
        
    }
    },[selectedSkid]) 


  if(skidsWithConfig.size===0 &&Tracker.skidsWithConfig===false &&!fetchingSkidsWithConfigRef.current){
          
          if (inProgress ===InteractionStatus.None ){
              console.log('No Skids Available, and no previous fetch, starting refetch')
              fetchingSkidsWithConfigRef.current = true
              fetchAvailableSkidsWithConfigHeaders(request, instance).
              then((res => res.json()))
              .then((items)=>{
                 console.log(items)
                  SkidDispatch({type:'addSkidsWithConfig',skid:null,skids:items})
                  TrackerDispatch({type:'skidsWithConfig',value:true})
                  fetchingSkidsWithConfigRef.current = false
              })

          }
  
      }
if(isPopulated(skidsWithConfig)&&selectedSkid&&!skidConnectedRef.current){
    console.log("got skids and selected skid:",selectedSkid)
    console.log("ready to connect")
    skidConnectedRef.current = true
    async function getToken(skid){
      console.log("getting connection token, triggered by instance token")
    //const url = new URL("https://rheo-api.azurewebsites.net/token")
    //const url = new URL("http://localhost:8000/token");
    const url = buildRheoURL("/token")
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + instanceToken); 
    const options = {
        method: "GET",
        headers: headers
      };
      url.search = new URLSearchParams({
       skid: skid
     });
     fetch(url, options).then(res=>res.json()).then((body)=>{     
      tokenfetchedRef.current = true 
      setToken(body.token)
     })
    }
    //if an ad token exists it uses it to get the ws token
    if(instanceToken && selectedSkid && isPopulated(skidsWithConfig)&&!tokenfetchedRef.current){
      getToken(skidsWithConfig.get(selectedSkid).name)
      fetchDefaultView(skidsWithConfig.get(selectedSkid).name)
      fetchSkidViews(skidsWithConfig.get(selectedSkid).name)

    }else{
      skidConnectedRef.current = false
    }
}
  
if(error !== '') {
  return (
    <>
    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
      <Typography variant='h5' component="h5" color="error.main" >{error}</Typography>
      </Box>
    </>
  )
}
if(!isLoaded) {
  return(   
    <>
      <div className='Charts-Container'>        
            <CircularProgress color='primary' size={50}/>       
      </div>
    </>            
    )
}else{
return(
    
<React.Fragment key={myKey}> 
<div style={{display:'flex', flexDirection:'row', padding:'10px'}}> 
{(lastMeasurement != null) && showFocused && Object.keys(lastMeasurement).length > 0 && viewConfig.charts.size > 0 &&
    <Focused data={lastMeasurement} tags={getCategoriesasStrings(viewConfig)} defaultFocused={['t_inlet_m','rho_e_m' ]} />
    }
<div>
<Box name='viewBox' sx={{ display:'inline-block', rowGap:1}}>

  <Paper name= 'ChartsPaper'elevation={10}  sx={{display:'flex', flexDirection:'row', flexWrap:'wrap', columnGap:1, justifyContent:'center', pb:'30px', mt: '30px', backgroundColor:'#273746'}} >
  <Box className='interactiveContainer' sx={{width:'100%' , 
   display: 'flex',  
  flexDirection:{ xs:'column',md:'row'}, justifyContent:{xs:'space-between',md:'flex-start'}, alignItems: {xs:'auto',md:'flex-start'}, p: '10px'}}>
    {skidsWithConfig.size > 0 &&
      <SelectForm title={'Select Skid'} 
        selected={selectedSkid} 
        options={mapToSelectOptions(skidsWithConfig)} 
        changeHandler={handleSkidSelect}/>
    }
    <SelectForm title={'Select Time Window'} 
      selected={time} 
      options={TimeOptions} 
      changeHandler={handleTimeSelect}
      optionDisplay={TimeOptionDisplay}/>
    {skidViews &&
      <SelectForm title ={'Select View'} 
      selected={viewConfig.name} 
      options={skidViews} 
      changeHandler={handleViewSelect}/>
      }
    <SelectForm title ={'Select Timezone'}
      selected={timezone}
      options={Array.from(avilableTimezones)}
      changeHandler={handleTimezoneSelect}
    />
    <Box sx={{px: {xs:'40px', md: '0px'}}}>
      {viewConfig.boundaries == 'single' &&
        <TargetForm key={'targetform'} singleBoundary={true}/>
       
      }
      {viewConfig.boundaries == 'double' &&
        <TargetForm key={'targetform double'} singleBoundary={false} />
      }
    </Box>
    <Box sx={{px: {xs:'40px', md: '0px'}}}>
      <FormGroup sx={{color:'white'}}>
        <FormControlLabel control={<Checkbox onChange={(e) => setShowFocused(e.target.checked)} sx={{color:'white'}}/>} label="Focused" />
      </FormGroup>
    </Box>
  </Box>
</Paper>
<Paper name="main-content-screen" elevation={10} sx={{display: 'flex', flexDirection: 'column', columnGap: 1, backgroundColor:'#273746', mt:'30px'}}>
<Typography variant="h6" component="h2" color="white" sx={{fontSize: {xs: '1em', md: '1em'}, mb:2, mt:1, ml:2, display:'flex', justifyContent:'left'}}><ArrowLeftOutlinedIcon fontSize='medium'/> Last Reading: {displayDate}</Typography>
  <Paper name= 'ChartsPaper' sx={{display:'flex', flexDirection:'row', flexWrap:'wrap', columnGap:1, justifyContent:'center', pb:'30px', backgroundColor:'#273746'}} >
  { 

Array.from(viewConfig.charts.values()).
map((chart,index)=>{
  //console.log(chart,viewConfig.charts)
  
  if(chart){
    if(isChartActive(chart,stats)){
      //console.log(`Chart ${chart.name} is active with index ${index}`)
      let hideYAxis = isAxisHidden(index,numActive)
      let yAxisOrientation = determineYaxisOrientation(index,numActive)
      //console.log(`yaxis is active :${hideYAxis}, with orientation: ${yAxisOrientation}`)
      return(
      <Charts 
        key={chart.name} 
        items = {liveitems} 
        isLoaded = {isLoaded} 
        error = {error} 
        //categories = {Array.from(chart.categories.values())} 
        chart = {chart.name}
        colours ={['#83EEFF','yellow',' #FF00FF ', '#ff9800','#1cec12', ' #03a9f4']} 
        groupName={chart.name} 
        groupIndex={index} 
        yAxis={yAxis} 
        stats = {stats} 
        isMoreThan720={moreThan720} 
        tempStats ={temporaryStats} 
        hideYaxis = {hideYAxis} 
        yAxisOrientation = {yAxisOrientation} 
        isHistoric = {false} 
        delta={time} 
        timezone={timezone}
        />)
    }
  }
  
}

)
}
  </Paper>
  <Paper>
  
  </Paper>
  </Paper>
  {
  trigger &&
    <Paper name= 'ChartsPaper'elevation={10}  sx={{display:'flex', flexDirection:'row', flexWrap:'wrap', columnGap:1, justifyContent:'center', mt:'30px', backgroundColor:'#273746'}} 
    ref={scrollRef}>
      <DisplacementChart items={displacementItems}/>
    </Paper>
  }   
  </Box>  
  <ToastList position="top-right" data={toasts} removeToast={removeToast} />
  </div>
  </div>
</React.Fragment>)
}
}

export default LiveChart;